import { render, staticRenderFns } from "./AddMeal.vue?vue&type=template&id=4045c64c&scoped=true&"
import script from "./AddMeal.vue?vue&type=script&lang=js&"
export * from "./AddMeal.vue?vue&type=script&lang=js&"
import style0 from "./AddMeal.vue?vue&type=style&index=0&id=4045c64c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4045c64c",
  null
  
)

export default component.exports